module.exports = __webpack_public_path__ + "static/media/triangle.43d91915.svg";